import { File, has3DFile, JobStatusSchema, JobStatusType } from "shared";

export const getIsEmbeddingLoading = (
  part:
    | {
        embeddingStatus: JobStatusType | null;
        hasEmbedding: boolean | null;
        files: File[];
      }
    | null
    | undefined,
) => {
  if (!part || !has3DFile(part) || part.hasEmbedding) {
    return false;
  }

  return (
    part.embeddingStatus === JobStatusSchema.enum.STANDBY ||
    part.embeddingStatus === JobStatusSchema.enum.PROCESSING
  );
};

export const getIsTopologicalEmbeddingLoading = (
  part:
    | {
        topologicalEmbeddingStatus: JobStatusType | null;
        hasTopologicalEmbedding: boolean | null;
        files: File[];
      }
    | null
    | undefined,
) => {
  if (!part || !has3DFile(part) || part.hasTopologicalEmbedding) {
    return false;
  }

  return (
    part.topologicalEmbeddingStatus === JobStatusSchema.enum.STANDBY ||
    part.topologicalEmbeddingStatus === JobStatusSchema.enum.PROCESSING
  );
};
